import type { ButtonProps } from '@archipro-design/aria';
import {
    useStyles,
    Flex,
    Switch,
    useTheme,
    pxToRem,
    Button,
} from '@archipro-design/aria';
import * as S from './ContactPage.mobile.style';
import { SearchLine } from '@archipro-design/icons';
import { AnimatePresence, motion } from 'framer-motion';
import { InPageSearchBar } from '@modules/search/components/in-page-search-bar/InPageSearchBar';
import { useToggle } from 'ahooks';
import * as SF from '../shared/SearchFilter.style';

interface ListMapNavTabProps {
    showMap: boolean;
    onMapTabClick: (showMap: boolean) => void;
    onSearchChange: (value?: string) => void;
    onSearchClick: () => void;
}

const ListMapNavTab = ({
    showMap,
    onMapTabClick,
    onSearchChange,
    onSearchClick,
}: ListMapNavTabProps) => {
    const { css } = useStyles();
    const theme = useTheme();
    const [searchDrawerOpen, { toggle: toggleSearchDrawer }] = useToggle(false);

    const buttonProps: ButtonProps = {
        size: 14,
        transparent: true,
        variables: () => ({
            buttonPadding: pxToRem(10),
        }),
        className: css(SF.MobileButtonFilters),
    };

    return (
        <>
            <Flex
                space="between"
                vAlign="center"
                className={css(S.ListMapSearchWrapper)}
            >
                <Flex
                    className={css(S.ListMapNavBox)}
                    gap="space-4"
                    vAlign="center"
                >
                    <span>LIST</span>
                    <Switch
                        checked={showMap}
                        onChange={() => onMapTabClick(!showMap)}
                        variables={{
                            backgroundColor:
                                theme.siteVariables.colors.charcoal[300],
                            switchWidth: pxToRem(43),
                            switchHeight: pxToRem(20),
                            thumbHeight: pxToRem(18),
                            thumbWidth: pxToRem(18),
                            checkedBackgroundColor:
                                theme.siteVariables.colors.charcoal[300],
                        }}
                    />
                    <span>MAP</span>
                </Flex>
                <Button
                    iconAfter={<SearchLine aria-label={'search'} />}
                    onClick={() => toggleSearchDrawer()}
                    {...buttonProps}
                >
                    Search
                </Button>
            </Flex>

            <AnimatePresence>
                {searchDrawerOpen && (
                    <motion.div
                        initial={{ height: 0 }}
                        animate={{ height: pxToRem(57) }}
                        exit={{ height: 0 }}
                        className={css(SF.MobileSearchDrawer)}
                    >
                        <InPageSearchBar
                            onSearchChange={onSearchChange}
                            onSearchClick={onSearchClick}
                            toggleSearchDrawer={() => toggleSearchDrawer()}
                            minChars={0}
                        />
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
};

export default ListMapNavTab;
